/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { AxiosResponse } from 'axios'

import getCookie from '../utils/getCookies'
import setCookies from '../utils/setCookies'
import { apisiseci, apisso } from './api'
import { postRemoveDevice } from './device'
import { UserData, UserDataMti } from './user'

// função auxiliar para setar cookies
const setCookie = (cname: string, cvalue: string, exdays: number): void => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cname}=${cvalue};${expires};path=/`
}

export const saveTokens = (tokenSSO: string): void => {
  document.cookie = `gov_access_token_sso=${encodeURIComponent(
    tokenSSO,
  )};path=/`
  setCookie('gov_access_token_sso', tokenSSO, 7)
}

export const clearStorage = (): void => {
  document.cookie =
    'gov_access_token_sso=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  document.cookie =
    'pathname_redirect_gov=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  document.cookie =
    'gov_user_data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
  sessionStorage.removeItem('@data-complements')
}

export const getPathToRedirectLogin = (): string => {
  if (process.env.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    const hasTwoFactore = getCookie('has_service_two_factores')

    if (hasTwoFactore && hasTwoFactore.length) {
      const data: { servico_id: number; servico_slug: string } =
        JSON.parse(hasTwoFactore)
      const urlTwoFactoreParams =
        data &&
        btoa(`servico_id=${data.servico_id}&servico_slug=${data.servico_slug}`)

      document.cookie =
        'has_service_two_factores=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      return `${process.env.REACT_APP_SSO}/sso/cidadao?client_id=${process.env.REACT_APP_CLIENT_ID}&dois_fatores=${urlTwoFactoreParams}`
    }
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${process.env.REACT_APP_SSO}/sso/cidadao?client_id=${process.env.REACT_APP_CLIENT_ID}`
  }
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return `${process.env.REACT_APP_SSO_SECUNDARY}/auth?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=${process.env.REACT_APP_RESPONSE_TYPE}&redirect_uri=${process.env.REACT_APP_REDIRECT_URI}`
}

export const loginRedirectPrivider = (pathname: string): void => {
  clearStorage()
  setCookies('pathname_redirect_gov', pathname)
  ;(window as any).open(getPathToRedirectLogin(), '_self')
}

export const logout = async () => {
  const tokenSiseci: string | null = getCookie('gov_access_token_sso')
  const deviceToken: string | null = getCookie('gov_access_device_token')

  if (tokenSiseci && deviceToken) {
    await postRemoveDevice(deviceToken, tokenSiseci)
  }
  if (process.env.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    clearStorage()
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    ;(window as any).open(
      `${process.env.REACT_APP_SSO}/sso/sair?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${window.location.href}`,
      '_self',
    )
  } else {
    clearStorage()
    ;(window as any).open(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `${process.env.REACT_APP_SSO_SECUNDARY}/logout?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=${process.env.REACT_APP_RESPONSE_TYPE}&redirect_uri=${window.location.href}`,
      '_self',
    )
  }
}

export const getDataUserSso = (token: string): Promise<AxiosResponse> =>
  apisso.get('/cidadaos/pro/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

export const getAdditionalDataUserSso = (
  token: string,
  cpf: string,
): Promise<AxiosResponse> =>
  apisso.get(`/cidadaos/complementar/${cpf}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

export const getDataUserMti = (
  token: string,
  access_token_mti: string,
): Promise<AxiosResponse> =>
  apisiseci.get('/profile/externo/', {
    headers: {
      Authorization: `Bearer ${token}`,
      'Authorization-Externo': access_token_mti,
    },
  })

export const validateUserSSO = (code: string): Promise<AxiosResponse> =>
  apisso.post(
    '/validar_cidadao/',
    {
      code,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

export const loginSigp = (
  code: string,
  redirect_uri?: string,
): Promise<AxiosResponse> => {
  if (
    process.env.REACT_APP_SSO_LOGIN_PROVIDER === 'primary' &&
    process.env.REACT_APP_ENV === 'local'
  ) {
    return apisiseci.post('/login-sigp/', {
      code,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
      client_id: process.env.REACT_APP_CLIENT_ID,
      redirect_uri: `${process.env.REACT_APP_URL}/login/callback/`,
    })
  }

  if (process.env.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    return apisiseci.post('/login-sigp/', {
      code,
    })
  }

  return apisiseci.post(
    '/login/externo/',
    {
      code,
      redirect_uri: redirect_uri || process.env.REACT_APP_REDIRECT_URI,
    },
    {
      headers: {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        Authorization: process.env.REACT_APP_API_SISECI_KEY,
      },
    },
  )
}

const mtiDataUserAdapter = (data: UserDataMti): UserData => {
  const dataF = <UserData>{
    nome: data.name,
    data_nascimento: data.dataNascimento,
    nome_mae: data.nomeMae,
    cpf: data.preferred_username || data.username || data.cpf,
    contato: {
      email: data.email,
    },
  }
  return dataF
}

export const getUserData = async (token: string, access_token_mti: string) => {
  if (process.env.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    const { data } = await getDataUserSso(token)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return data[0]
  }

  const { data } = await getDataUserMti(access_token_mti, token)

  console.log('DATAUSER', data)
  return mtiDataUserAdapter(data)
}

export const checkCPF = (cpf: string): Promise<AxiosResponse> =>
  apisso.post('/admin/checar/cpf/', { cpf })

export const sendCodeForSISECI = async (code: string, history: any) => {
  const pathname = getCookie('pathname_redirect_gov')
  try {
    const { data } = await loginSigp(
      code,
      `${window.location.origin}${window.location.pathname}`,
    )

    // TODO: verificar o perfil do cidadão no jwt

    if (data.access_token) {
      saveTokens(data.access_token)
      const spathname = pathname === '/' ? '/' : pathname
      history.push(spathname || '/', {
        message: data.message ? data.message : '',
      })
    }
  } catch (err) {
    clearStorage()
    history.push(pathname || '/', {
      message: 'Erro ao processar o login',
    })
  }
}

export const getImageProfile = async (token: string) =>
  apisso.get('cidadaos/foto/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
